export default "__VITE_ASSET__xkBx$tX6__"